export enum InsightsPaths {
  DEAL_HEALTH = 'deal-health',
  CHINA_DEAL_HEALTH = 'china-deal-health',
  US_DEAL_HEALTH = 'us-deal-health',
  PROOF_OF_PLAY = 'proof-of-play',
  CHINA_PROOF_OF_PLAY = 'china-proof-of-play',
  POP_LIVE_MONITORING = 'pop-live-monitoring',
  REVENUE_INSIGHTS = 'revenue-insights',
  INVENTORY_RESERVATION = 'inventory-reservation',
}
